module.exports = __webpack_public_path__ + "static/media/back.21e770cf.gif";